<template>
  <div
    class="edit-station edit-station-parameters"
  >
    <input-element
      v-if="sensorData.status.sdaddr"
      :title="$t('messages.sensors.sdSetup.sdaddr')"
      :text="settings.sdaddr"
      @change="setValue(parseFloat($event), 'sdaddr')"
    />
    <select-element
      v-if="sensorData.status.sdtype"
      class="select-element--full"
      :title="$t('messages.sensors.sdSetup.sdtype')"
      :value="settings.sdtype"
      :list="types"
      @change="setValue($event.value, 'sdtype')"
    />
    <input-element
      v-if="sensorData.status.kfact"
      :title="$t('messages.sensors.sdSetup.kfact')"
      :type="'number'"
      :text="settings.kfact"
      :min="-999.999"
      :max="999.999"
      :step="0.001"
      @change="setValue(parseFloat($event), 'kfact')"
    />
    <input-element
      v-if="sensorData.status.offset"
      :title="$t('messages.sensors.sdSetup.offset')"
      :type="'number'"
      :text="settings.offset"
      :min="-999.999"
      :max="999.999"
      :step="0.001"
      @change="setValue(parseFloat($event), 'offset')"
    />
    <input-element
      v-if="sensorData.status.adjust"
      :title="$t('messages.sensors.sdSetup.adjust')"
      :type="'number'"
      :text="settings.adjust"
      :min="-100"
      :max="100"
      :step="0.1"
      @change="setValue(parseFloat($event), 'adjust')"
    />
    <input-element
      v-if="sensorData.status.units"
      :title="$t('messages.sensors.sdSetup.units')"
      :text="settings.units"
      :max-length="3"
      @change="setValue($event, 'units')"
    />
  </div>
</template>

<script>
import{SocketHandler, LifeCycle, MicroService, UnitSystem} from'@/assets/javascript/mixins/Mixins'
import InputElement from'@/components/elements/InputElement.vue'
import SelectElement from'@/components/elements/SelectElementReactive.vue'
import {convertToOptions} from '@/assets/javascript/utilities'

export default {
  name: 'EditSensorDecoderSettings',
  components: {
    'input-element': InputElement,
    'select-element': SelectElement
  },
  mixins: [SocketHandler, LifeCycle, MicroService, UnitSystem],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return {}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return {}
      }
    },
    blankSensor: {
      type: Object,
      default() {
        return {}
      }
    },
    sensorData: {
      type: Object,
      default: function() {
        return {
          id: null,
          sdaddr: null,
          sdtype: null,
          kfact: null,
          offset: null,
          adjust: null,
          units: null
        }
      }
    },
    store: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      types: []
    }
  },
  computed: {
    settings() {
      return this.sensorData ? this.sensorData.data : {}
    }
  },
  mounted() {
    this.getInputs()
  },
  methods: {
    updateSensor(data) {
      console.log('updating sensor')
      this.sendMicroServiceRequest({
        method: 'POST',
        url: `api/authenticated/function/updatesdsetup?ctrlid=${data.ctrlid}&id=${data.id}`,
        data
      })
      .then((response) => {
        if(response.status !== 200)
          console.error(response)
      }).catch(console.error)
    },
    getInputs() {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdsetupsettingsdropdown?enum=${this.settings.senstype}&language_code=en-US`
      })
      .then((response) => {
        response.data && response.data.getsdsetupsettingsdropdown
        ? this.$set(this, 'types', convertToOptions(response.data.getsdsetupsettingsdropdown, 'enum', 'lang'))
        : console.error('no data for getsdsetupsettingsdropdown')
      }).catch(console.error)
    },
    setValue(option, name) {
      const value = option.value !== undefined ? option.value : option
      this.$set(this.settings, name, value)
      this.updateSensor(Object.assign({}, this.blankSensor, this.settings))
    }
  }
}
</script>
